"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRocket32 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", role: "img" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ transform: "translate(0 .5)", fill: "none", fillRule: "evenodd" }, { children: [(0, jsx_runtime_1.jsx)("rect", { fill: "none", width: 32, height: 32, rx: 1 }), (0, jsx_runtime_1.jsx)("path", { d: "m18.896 8.02 5.064 5.063m-7.115-3.992C13.888 8.02 10.8 8.661 8.2 12.1l2.707 2.713m6.28 6.28L19.9 23.8c3.44-2.6 4.08-5.688 3.009-8.645M14.7 22.5l-5.2-5.2S13.72 7.09 25.526 6.474C24.86 18.229 14.7 22.5 14.7 22.5Zm2.925-6.5a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25ZM7.471 21.771a1.95 1.95 0 0 1 2.758 2.758c-.761.761-3.867 1.11-3.867 1.11s.348-3.106 1.11-3.868Z", strokeLinecap: "square", stroke: "currentColor" })] })) }))); };
exports.default = SvgRocket32;
